module.exports = __webpack_public_path__ + "static/img/light.135cff73.svg";